<template>
	<div class="position-relative">
		<div class="mobile-none width-60 text-center d-inline-block position-absolute bg-smoth-light cursor-pointer" style="width: 20px;left: 0;z-index: 9" @click="xScroll('left', 'room-facilities')">
			<img src="../../assets/img/icon/down-arrow.png" width="18" class="next-button" style="transform: rotate(90deg);margin-top: 12px;" />
    </div>
    <div class="div-wrapper mx-auto d-inline-block m-width-100" id="room-facilities" style="width: 98%;">
      <div class="text-center" style="width: max-content">
        <div class="text-center d-inline-block" >
          <div class="width-80px height-100px d-inline-block align-bottom overflow-hidden" v-for="data in facilities">
            <div class="rounded-10 p-5px mt-1 w-45px mx-auto d-inline-block bg-transparent-green">
              <i class="text-green size-icon position-relative top-7px" :class="data.icon"></i>
            </div>
            <p class="body-3-3 text-14 mt-1 text-center">{{data.name}}</p>
          </div>
        </div>
      </div>
    </div>
     <!-- <div class="text-center pb-3">
       <p class="mb-0 text-green body-2 font-semibold cursor-pointer" @click="all_facilities = true">See all facilities</p>
     </div> -->
    <div class="mobile-none width-60 text-center d-inline-block bg-smoth-light position-absolute cursor-pointer" style="width: 20px;right: 5px;top: 0;z-index: 9" @click="xScroll('right', 'room-facilities')">
      <img src="../../assets/img/icon/down-arrow.png" width="18" class="next-button" style="transform: rotate(-90deg);margin-top: 12px;" />
    </div>
    <!-- <transition name="fade">
      <template v-if="all_facilities">
        <div class="position-relative" style="z-index: 1040;">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block nav-bottom" style="bottom:0px">
              <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="container px-4 py-3 bg-white box-shadow-main" style="height: 90vh;min-height: 100%">
                      <div class="mb-2 pb-1">
                        <img src="../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="toggleFacilities()">
                        <p class="mb-0 body-2-2 text-16 font-bold d-inline-block">Facilities</p>
                      </div>
                      <div class="scroll-hide-mobile" style="height: 90vh;overflow-y: scroll;">
                        <p class="mb-2 body-2-2 font-semibold text-16 pt-3">Public Facilities</p>
                        <ul v-for="data in facilities">
                          <li class="body-2-2">{{data.name}}</li>
                        </ul>
                        <p class="mb-2 body-2-2 font-semibold text-16 pt-3">Room Facilities</p>
                        <ul v-for="data in facilities">
                          <li class="body-2-2">{{data.name}}</li>
                        </ul>
                        <div class="height-75px"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition> -->
    <transition name="fade">
      <template v-if="all_facilities">
        <PopUpBackground></PopUpBackground>
      </template>
    </transition>
	</div>
</template>
<script>
  import PopUpBackground from '@/components/dev/PopUpBackground';
	export default{
    components: {
      PopUpBackground
    },
    data() {
      return {
        all_facilities: false,
        facilities: [
          {
            name: 'Wi-Fi',
            icon: 'iconsmind-Wifi'
          },
          {
            name: 'Music',
            icon: 'iconsmind-Play-Music'
          },
          {
            name: '24 Hours',
            icon: 'iconsmind-Support'
          },
          {
            name: 'TV',
            icon: 'iconsmind-Monitor-3'
          },
          {
            name: 'Fan',
            icon: 'iconsmind-Fan'
          },
          {
            name: 'Love',
            icon: 'iconsmind-Heart'
          }
        ]
      }
    },
		methods: {
			xScroll(type, id) {
        let content = document.querySelector("#" + id);
          if (type == 'left') {
            // var slideTimer = setInterval(function(){
              content.scrollLeft -= 80;
              // if(content.scrollLeft >= 80){
                  // window.clearInterval(slideTimer);
                // }
            // }, 25)
          }else {
            // var slideTimer = setInterval(function(){
              content.scrollLeft += 80;
              // if(content.scrollLeft >= 80){
                // window.clearInterval(slideTimer);
              // }
            // }, 25)
          }
      },
      toggleFacilities(){
        this.all_facilities = !this.all_facilities
      }
		}
	}
</script>
<style scoped>
@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dev/Facilities.vue